// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"_f109c9d3","fullBleedListWrapper":"_e24fd7f8","carouselItem":"_fb9c3b35","moduleContainer":"_45cfeecd","isFullBleed":"_fef3c9d3","fullWidth":"_dd3a8045"};